import Cookies from "js-cookie";

const auth_token_name = "ozone_sa_auth";
const auth_refresh_token = "ozone_sa_refresh_auth";
const fullDomain = typeof window !== "undefined" ? window.location.hostname : "";

export const setStorageItem = (key, value) => {
  if (typeof window !== "undefined" && "localStorage" in window) {
    localStorage.setItem(key, value);
  }
};

export const getStorageItem = (key) => {
  if (typeof window !== "undefined" && "localStorage" in window) {
    return localStorage.getItem(key);
  }
};

export const removeStorageItem = (key) => {
  if (typeof window !== "undefined" && "localStorage" in window) {
    localStorage.removeItem(key);
  }
};

export const setAuthToken = (value) => {
  setStorageItem(auth_token_name, value);
};

export const setRefreshToken = (value) => {
  setStorageItem(auth_refresh_token, value);
};

export const getToken = () => getStorageItem(auth_token_name);
export const getRefreshToken = () => getStorageItem(auth_refresh_token);

export const clearToken = () => {
  removeStorageItem(auth_token_name);
  removeStorageItem(auth_refresh_token);
};

export const setSessionStorage = (key, value) => {
  sessionStorage.setItem(key, value);
};

export const getSessionStorage = (key) => {
  return sessionStorage.getItem(key);
};

export const removeSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const setCookie = (key, value) => {
  try {
    const date = new Date();
    date.setTime(date.getTime() + 2 * 60 * 1000);
    const twoMinLater = new Date(date);
    Cookies.set(key, value, {
      expires: twoMinLater,
      domain: fullDomain,
      Secure: true,
      sameSite: "None",
    });
  } catch (error) {
    console.error(error);
  }
};

export const getCookie = () => Cookies.get("auth");

export function clearCookies() {
  Cookies.remove("auth", {
    path: "/",
    domain: fullDomain,
  });
}
